import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import DatePicker from 'react-datepicker';
import Fa from 'react-fontawesome';

const CustomInput = ({ onClick }) => (
  <a
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      onClick();
    }}
    href=""
  >
    <Fa name="clock-o" /> Reschedule
  </a>
);

class RescheduleButton extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleChange = this.handleChange.bind(this);
  }


  handleChange(date) {
    this.props.onChange(date);
  }

  render() {
    const {
      children, localTime, foreignTime, disabled,
      rescheduling,
    } = this.props;
    // const isForeignTime = foreignTime !== null && foreignTime !== undefined;
    // const date = isForeignTime ? foreignTime.date : localTime.date;
    const date = localTime && localTime.date && localTime.date.isValid() ? localTime.date : null;
    return (
      <div className="clearfix">
        <div className="pull-right" style={{ position: 'relative', zIndex: 100 }}>
          {!rescheduling &&
            <DatePicker
              selected={date}
              disabled={disabled}
              popperModifiers={{
                preventOverflow: {
                  enabled: true,
                  escapeWithReference: false,
                  boundariesElement: 'viewport',
                },
              }}
              minDate={moment().startOf('day').toDate()}
              onChange={this.handleChange}
              customInput={<CustomInput />}
            />
          }
          {rescheduling &&
            <div className="text-muted">
              <Fa name="spinner" spin /> Updating
            </div>
          }
        </div>
        {children}
      </div>
    );
  }
}

RescheduleButton.propTypes = {
  children: PropTypes.node,
  disabled: PropTypes.bool,
  rescheduling: PropTypes.bool,
  onChange: PropTypes.func,
  localTime: PropTypes.shape({
    date: PropTypes.instanceOf(moment),
  }).isRequired,
  foreignTime: PropTypes.shape({
    date: PropTypes.instanceOf(moment),
    utc: PropTypes.string,
  }),
};
RescheduleButton.defaultProps = {
  children: null,
  disabled: false,
  rescheduling: false,
  onChange: () => {},
  foreignTime: {
    date: null,
    utc: null,
  },
};

export default RescheduleButton;
